import { IQuoteParams } from '@nibtravel/shared/data-access/quote';
import { DateUtil, QuickQuoteInput } from '@nibtravel/shared/util/models';
import { parse, format, isValid } from 'date-fns';
import { ParamMap } from '@angular/router';

export function parseDate(
  day?: string,
  month?: string,
  year?: string
): string | undefined {
  if (day && day != '' && month && month != '' && year && year != '') {
    const value = parse(`${year}-${month}-${day}`, 'yyyy-MM-dd', new Date());
    if (isValid(value)) {
      return format(value, DateUtil.DisplayFormat);
    }
  }
  return undefined;
}

export function parseQuoteParams(
  params: Partial<QuickQuoteInput>
): IQuoteParams {
  const destinationCountryCodes: string[] =
    params?.countryCodes?.split(',').filter(Boolean) ?? [];
  const departureDate = parseDate(
    params.depDay,
    params.depMonth,
    params.depYear
  );
  const coverEndDate = parseDate(
    params.retDay,
    params.retMonth,
    params.retYear
  );
  const ages = params?.ages?.split(',') ?? [];
  const combinedAges = params?.combinedAges?.split(',') ?? [];
  const travelAges: number[] = [...ages, ...combinedAges]
    .filter(Boolean)
    .map(Number);
  const campaignCode = getCampaignCode(params);
  const partnerCode = getPartnerCode(params);
  const quoteType = params.quoteType;
  const dependentAge = params?.dependentAge;
  return {
    destinationCountryCodes,
    departureDate,
    coverEndDate,
    travelAges,
    campaignCode,
    partnerCode,
    quoteType,
    dependentAge,
  };
}

export function parseEmailParams(
  params: Partial<QuickQuoteInput>
): Partial<IQuoteParams> {
  const campaignCode = getCampaignCode(params);
  const partnerCode = getPartnerCode(params);

  return {
    campaignCode,
    partnerCode,
  };
}

export function getCampaignCode(params?: ParamMap | any): string | undefined {
  if (isParamMap(params)) {
    return (
      params.get('promo_code') ||
      params.get('campaignCode') ||
      params.get('campaign') ||
      undefined
    );
  }
  return params?.promo_code || params?.campaignCode || params?.campaign;
}

export function getPartnerCode(params?: ParamMap | any): string | undefined {
  if (isParamMap(params)) {
    return params.get('partnerCode') || undefined;
  }
  return params?.partnerCode;
}

export function isParamMap(params: any): params is ParamMap {
  return typeof params.get === 'function';
}
